import React, { useState, useEffect, useRef } from 'react';
import { db } from '../config/firebase';
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import Modal from 'react-modal';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';
import { FaDownload, FaEdit, FaTrash } from 'react-icons/fa';
import ReportModal from './ReportModal';
import '../css/PersonRow.css';
import TooltipPortal from './TooltipPortal';

function PersonRow({
  person,
  earningsData,
  numOfWeeks,
  startWeek,
  selectedYear,
  selectedMonth,
  selectedPeriod,
  userPeriodData,
  onDeletePerson,
  onUpdatePerson,
  refreshData,
  firms = [],
  selectedNationality,
}) {
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [isFinancialModalOpen, setIsFinancialModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isEarningsModalOpen, setIsEarningsModalOpen] = useState(false);

  const [startMonth, setStartMonth] = useState(person.startMonth || new Date().getMonth() + 1);
  const [startYear, setStartYear] = useState(person.startYear || new Date().getFullYear());
  const [isRowSelected, setIsRowSelected] = useState(false);

  const [name, setName] = useState(person.name);
  const [nationality, setNationality] = useState(person.nationality);
  const [tekuciRacun, setTekuciRacun] = useState(person.tekuciRacun || '');
  const [zasticeniRacun, setZasticeniRacun] = useState(person.zasticeniRacun || '');
  const [riderID, setRiderID] = useState(
    (userPeriodData.riderID || person.riderID || '').trim().toLowerCase()
  );
  const [city, setCity] = useState(person.city || '');
  const [firmId, setFirmId] = useState(person.firmId || 'default');
  const [email, setEmail] = useState(person.email || 'nema');
  const [comment, setComment] = useState(person.comment || '');

  const [appKnjigDefault, setAppKnjigDefault] = useState(person.appKnjig || 0);
  const [doprinosiDefault, setDoprinosiDefault] = useState(person.doprinosi || 0);
  const [feeDefault, setFeeDefault] = useState(person.fee || 0);

  const [fee, setFee] = useState(
    userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0
  );
  const [appKnjig, setAppKnjig] = useState(
    userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0
  );
  const [doprinosi, setDoprinosi] = useState(
    userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0
  );
  const [renta, setRenta] = useState(
    userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0
  );
  const [rentSmjestaj, setRentSmjestaj] = useState(
    userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0
  );
  const [oprema, setOprema] = useState(
    userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0
  );
  const [akontacija, setAkontacija] = useState(
    userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0
  );
  const [gorivo, setGorivo] = useState(
    userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0
  );
  const [ostalo, setOstalo] = useState(
    userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0
  );
  const [bonus, setBonus] = useState(
    userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0
  );
  const [tarifa, setTarifa] = useState(
    userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0
  );
  const [depozit, setDepozit] = useState(
    userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0
  );
  const [struja, setStruja] = useState(
    userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0
  );
  const [glovoTax, setGlovoTax] = useState(
    userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0
  );
  const [napomena, setNapomena] = useState(userPeriodData.napomena || '');

  const [rentaDefault, setRentaDefault] = useState(person.renta || 0);
  const [rentSmjestajDefault, setRentSmjestajDefault] = useState(person.rentSmjestaj || 0);
  const [opremaDefault, setOpremaDefault] = useState(person.oprema || 0);
  const [akontacijaDefault, setAkontacijaDefault] = useState(person.akontacija || 0);
  const [gorivoDefault, setGorivoDefault] = useState(person.gorivo || 0);
  const [ostaloDefault, setOstaloDefault] = useState(person.ostalo || 0);
  const [bonusDefault, setBonusDefault] = useState(person.bonus || 0);
  const [tarifaDefault, setTarifaDefault] = useState(person.tarifa || 0);
  const [depozitDefault, setDepozitDefault] = useState(person.depozit || 0);
  const [strujaDefault, setStrujaDefault] = useState(person.struja || 0);
  const [glovoTaxDefault, setGlovoTaxDefault] = useState(person.glovoTax || 0);

  const [earnings, setEarnings] = useState([]);
  const [editedWeeks, setEditedWeeks] = useState(new Array(numOfWeeks).fill(false));
  const [feeAmount, setFeeAmount] = useState((0).toFixed(2));

  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: '' });

  const handleMouseEnter = (e) => {
    if (!person.comment) return;
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      visible: true,
      x: rect.right,
      y: rect.top + rect.height / 2,
      content: person.comment,
    });
  };
  const handleMouseMove = (e) => {
    if (!person.comment) return;
    const rect = e.target.getBoundingClientRect();
    setTooltip((prev) => ({ ...prev, x: rect.right, y: rect.top + rect.height / 2 }));
  };
  const handleMouseLeave = () => {
    setTooltip((prev) => ({ ...prev, visible: false }));
  };

  useEffect(() => {
    const earningsArray = new Array(numOfWeeks).fill(0);

    earningsData.forEach((earning) => {
      if (earning.userId === person.id) {
        let weekIndex = earning.week - startWeek;
        if (weekIndex >= 0 && weekIndex < numOfWeeks) {
          earningsArray[weekIndex] = earning.amount;
        }
      }
    });

    setEarnings(earningsArray);
  }, [earningsData, person.id, numOfWeeks, startWeek]);

  const zaradaTotal = earnings.reduce((sum, earning) => sum + earning, 0);
  const calculatedFeeAmount = ((zaradaTotal * fee) / 100).toFixed(2);
  const total1 = (zaradaTotal - (zaradaTotal * fee) / 100).toFixed(2);
  const total2 = (
    zaradaTotal -
    (zaradaTotal * fee) / 100 -
    appKnjig -
    doprinosi -
    renta -
    rentSmjestaj -
    oprema -
    akontacija -
    gorivo -
    ostalo -
    (person.nationality === 'Stranac' ? tarifa + depozit + struja + glovoTax : 0) +
    bonus
  ).toFixed(2);

  useEffect(() => {
    setName(person.name);
    setNationality(person.nationality);
    setTekuciRacun(person.tekuciRacun || '');
    setZasticeniRacun(person.zasticeniRacun || '');
    setRiderID((userPeriodData.riderID || person.riderID || '').trim().toLowerCase());
    setCity(person.city || '');
    setFirmId(person.firmId || 'default');
    setComment(person.comment || '');
    setRentaDefault(person.renta || 0);
    setRentSmjestajDefault(person.rentSmjestaj || 0);
    setOpremaDefault(person.oprema || 0);
    setAkontacijaDefault(person.akontacija || 0);
    setGorivoDefault(person.gorivo || 0);
    setOstaloDefault(person.ostalo || 0);
    setBonusDefault(person.bonus || 0);
    setAppKnjigDefault(person.appKnjig || 0);
    setDoprinosiDefault(person.doprinosi || 0);
    setFeeDefault(person.fee || 0);

    if (person.nationality === 'Stranac') {
      setTarifaDefault(person.tarifa || 0);
      setDepozitDefault(person.depozit || 0);
      setStrujaDefault(person.struja || 0);
      setGlovoTaxDefault(person.glovoTax || 0);
    }
  }, [person, userPeriodData]);

  useEffect(() => {
    setStartMonth(person.startMonth || new Date().getMonth() + 1);
    setStartYear(person.startYear || new Date().getFullYear());
    setFee(userPeriodData.fee !== undefined ? userPeriodData.fee : person.fee || 0);
    setAppKnjig(userPeriodData.appKnjig !== undefined ? userPeriodData.appKnjig : person.appKnjig || 0);
    setDoprinosi(userPeriodData.doprinosi !== undefined ? userPeriodData.doprinosi : person.doprinosi || 0);
    setRenta(userPeriodData.renta !== undefined ? userPeriodData.renta : person.renta || 0);
    setRentSmjestaj(userPeriodData.rentSmjestaj !== undefined ? userPeriodData.rentSmjestaj : person.rentSmjestaj || 0);
    setOprema(userPeriodData.oprema !== undefined ? userPeriodData.oprema : person.oprema || 0);
    setAkontacija(userPeriodData.akontacija !== undefined ? userPeriodData.akontacija : person.akontacija || 0);
    setGorivo(userPeriodData.gorivo !== undefined ? userPeriodData.gorivo : person.gorivo || 0);
    setOstalo(userPeriodData.ostalo !== undefined ? userPeriodData.ostalo : person.ostalo || 0);
    setBonus(userPeriodData.bonus !== undefined ? userPeriodData.bonus : person.bonus || 0);
    setNapomena(userPeriodData.napomena !== undefined ? userPeriodData.napomena : person.napomena || '');
    if (person.nationality === 'Stranac') {
      setTarifa(userPeriodData.tarifa !== undefined ? userPeriodData.tarifa : person.tarifa || 0);
      setDepozit(userPeriodData.depozit !== undefined ? userPeriodData.depozit : person.depozit || 0);
      setStruja(userPeriodData.struja !== undefined ? userPeriodData.struja : person.struja || 0);
      setGlovoTax(userPeriodData.glovoTax !== undefined ? userPeriodData.glovoTax : person.glovoTax || 0);
    }
  }, [userPeriodData, person]);

  useEffect(() => {
    setFeeAmount(calculatedFeeAmount);
  }, [zaradaTotal, fee]);

  const openReportModal = () => setIsReportModalOpen(true);
  const closeReportModal = () => setIsReportModalOpen(false);
  const openPersonModal = () => setIsPersonModalOpen(true);
  const closePersonModal = () => setIsPersonModalOpen(false);
  const openFinancialModal = () => setIsFinancialModalOpen(true);
  const closeFinancialModal = () => setIsFinancialModalOpen(false);
  const openEarningsModal = () => setIsEarningsModalOpen(true);
  const closeEarningsModal = () => {
    setEditedWeeks(new Array(numOfWeeks).fill(false));
    setIsEarningsModalOpen(false);
  };

  const transferEarningsPeriod = async () => {
    try {
      const earningsQuery = query(
        collection(db, 'earnings'),
        where('userId', '==', person.id),
        where('week', 'in', [3, 4, 5]),
        where('period', '==', 1)
      );
      const earningsSnapshot = await getDocs(earningsQuery);
      const updatePromises = earningsSnapshot.docs.map((doc) =>
        updateDoc(doc.ref, { period: 2 })
      );
      await Promise.all(updatePromises);
      alert('Earnings periods successfully updated to 2');
    } catch (error) {
      console.error('Error updating earnings periods:', error);
      alert('Failed to update earnings periods.');
    }
  };

  const handleSavePerson = async () => {
    try {
      const normalizedRiderID = riderID.trim().toLowerCase();
      if (normalizedRiderID !== (person.riderID || '').trim().toLowerCase()) {
        const riderIDQuery = query(
          collection(db, 'users'),
          where('riderID', '==', normalizedRiderID)
        );
        const riderIDSnapshot = await getDocs(riderIDQuery);
        if (!riderIDSnapshot.empty) {
          alert('Rider ID već postoji. Molimo unesite jedinstveni Rider ID.');
          return;
        }
      }

      if (person.nationality === 'Stranac' && nationality === 'Hrvat') {
        await transferEarningsPeriod();
      }

      const updatedPerson = {
        ...person,
        name,
        nationality,
        tekuciRacun,
        zasticeniRacun,
        riderID: normalizedRiderID,
        city,
        firmId,
        email: email,
        comment,
        appKnjig: appKnjigDefault,
        doprinosi: doprinosiDefault,
        fee: feeDefault,
        renta: rentaDefault,
        rentSmjestaj: rentSmjestajDefault,
        oprema: opremaDefault,
        akontacija: akontacijaDefault,
        gorivo: gorivoDefault,
        ostalo: ostaloDefault,
        bonus: bonusDefault,
        startMonth,
        startYear,
      };

      if (nationality === 'Stranac') {
        updatedPerson.tarifa = tarifaDefault;
        updatedPerson.depozit = depozitDefault;
        updatedPerson.struja = strujaDefault;
        updatedPerson.glovoTax = glovoTaxDefault;
      } else {
        delete updatedPerson.tarifa;
        delete updatedPerson.depozit;
        delete updatedPerson.struja;
        delete updatedPerson.glovoTax;
      }

      await updateDoc(doc(db, 'users', person.id), updatedPerson);
      onUpdatePerson(updatedPerson);
      closePersonModal();
      alert('Promjene osnove osobe su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju korisnika:', e);
      alert('Došlo je do greške prilikom spremanja promjena. Pokušajte ponovno.');
    }
  };

  const handleSaveFinancial = async () => {
    try {
      const userPeriodQuery = query(
        collection(db, 'userPeriodData'),
        where('userId', '==', person.id),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth),
        where('period', '==', selectedPeriod)
      );
      const userPeriodSnapshot = await getDocs(userPeriodQuery);

      const dataToSave = {
        fee,
        appKnjig,
        doprinosi,
        renta,
        rentSmjestaj,
        oprema,
        akontacija,
        gorivo,
        ostalo,
        bonus,
        napomena,
        zaradaTotal: zaradaTotal.toFixed(2),
        feeAmount: feeAmount,
        total1: total1,
        total2: total2,
      };

      if (person.nationality === 'Stranac') {
        dataToSave.tarifa = tarifa;
        dataToSave.depozit = depozit;
        dataToSave.struja = struja;
        dataToSave.glovoTax = glovoTax;
      } else {
        dataToSave.tarifa = 0;
        dataToSave.depozit = 0;
        dataToSave.struja = 0;
        dataToSave.glovoTax = 0;
      }

      if (!userPeriodSnapshot.empty) {
        const docRef = userPeriodSnapshot.docs[0].ref;
        await updateDoc(docRef, dataToSave);
      } else {
        dataToSave.userId = person.id;
        dataToSave.year = selectedYear;
        dataToSave.month = selectedMonth;
        dataToSave.period = selectedPeriod;
        await addDoc(collection(db, 'userPeriodData'), dataToSave);
      }

      refreshData();
      closeFinancialModal();
      alert('Financijske promjene su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri ažuriranju financijskih podataka:', e);
      alert('Došlo je do greške prilikom spremanja financijskih promjena. Pokušajte ponovno.');
    }
  };

  const handleSaveEarnings = async () => {
    try {
      for (let i = 0; i < earnings.length; i++) {
        if (!editedWeeks[i]) continue;

        const weekNumber = startWeek + i;
        const amount = earnings[i];

        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          await updateDoc(earningsDocRef, {
            amount: amount,
            period: selectedPeriod,
          });
        } else if (amount !== 0) {
          await addDoc(collection(db, 'earnings'), {
            userId: person.id,
            year: selectedYear,
            month: selectedMonth,
            week: weekNumber,
            amount: amount,
            firmId: person.firmId,
            period: selectedPeriod,
          });
        }
      }

      refreshData();
      setEditedWeeks(new Array(numOfWeeks).fill(false));
      closeEarningsModal();
      alert('Zarade po tjednima su uspješno spremljene!');
    } catch (e) {
      console.error('Greška pri spremanju zarada:', e);
      alert('Došlo je do greške prilikom spremanja zarada. Pokušajte ponovno.');
    }
  };

  const handleDeleteEarning = async (weekIndex) => {
    if (window.confirm(`Jeste li sigurni da želite obrisati zaradu za tjedan ${startWeek + weekIndex}?`)) {
      try {
        const weekNumber = startWeek + weekIndex;
        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', weekNumber),
          where('firmId', '==', person.firmId)
        );

        const earningsSnapshot = await getDocs(earningsQuery);

        if (!earningsSnapshot.empty) {
          const earningsDocRef = earningsSnapshot.docs[0].ref;
          await deleteDoc(earningsDocRef);

          const updatedEarnings = [...earnings];
          updatedEarnings[weekIndex] = 0;
          setEarnings(updatedEarnings);

          const updatedEditedWeeks = [...editedWeeks];
          updatedEditedWeeks[weekIndex] = false;
          setEditedWeeks(updatedEditedWeeks);

          refreshData();
          alert(`Zarada za tjedan ${weekNumber} je uspješno obrisana!`);
        } else {
          alert(`Nema zarade za tjedan ${weekNumber} za brisanje.`);
        }
      } catch (e) {
        console.error('Greška pri brisanju zarade:', e);
        alert('Došlo je do greške prilikom brisanja zarade. Pokušajte ponovno.');
      }
    }
  };

  const handleDeleteFinancialData = async () => {
    if (window.confirm('Jeste li sigurni da želite resetirati financijske podatke na zadane vrijednosti?')) {
      try {
        const userPeriodQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('period', '==', selectedPeriod)
        );
        const userPeriodSnapshot = await getDocs(userPeriodQuery);

        if (!userPeriodSnapshot.empty) {
          const docRef = userPeriodSnapshot.docs[0].ref;
          await deleteDoc(docRef);
          setFee(person.fee || 0);
          setAppKnjig(person.appKnjig || 0);
          setDoprinosi(person.doprinosi || 0);
          setRenta(person.renta || 0);
          setRentSmjestaj(person.rentSmjestaj || 0);
          setOprema(person.oprema || 0);
          setAkontacija(person.akontacija || 0);
          setGorivo(person.gorivo || 0);
          setOstalo(person.ostalo || 0);
          setBonus(person.bonus || 0);
          setNapomena('');
          alert('Financijski podaci su resetirani na zadane vrijednosti.');
          refreshData();
        } else {
          alert('Nema financijskih podataka za brisanje.');
        }
      } catch (e) {
        console.error('Greška pri brisanju financijskih podataka:', e);
        alert('Došlo je do greške prilikom brisanja financijskih podataka. Pokušajte ponovno.');
      }
    }
  };

  const handleDelete = async () => {
    if (window.confirm(`Jeste li sigurni da želite obrisati ${person.name}?`)) {
      try {
        const earningsQuery = query(
          collection(db, 'earnings'),
          where('userId', '==', person.id)
        );
        const earningsSnapshot = await getDocs(earningsQuery);
        const deleteEarningsPromises = earningsSnapshot.docs.map((docSnap) =>
          deleteDoc(doc(db, 'earnings', docSnap.id))
        );
        await Promise.all(deleteEarningsPromises);

        const periodDataQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id)
        );
        const periodDataSnapshot = await getDocs(periodDataQuery);
        const deletePeriodDataPromises = periodDataSnapshot.docs.map((docSnap) =>
          deleteDoc(doc(db, 'userPeriodData', docSnap.id))
        );
        await Promise.all(deletePeriodDataPromises);

        await deleteDoc(doc(db, 'users', person.id));
        onDeletePerson(person.id);
        closePersonModal();
        closeFinancialModal();
        alert('Korisnik je uspješno izbrisan!');
      } catch (e) {
        console.error('Greška pri brisanju korisnika:', e);
        alert('Došlo je do greške prilikom brisanja korisnika. Pokušajte ponovno.');
      }
    }
  };

  const handleEarningChange = (e, weekIndex) => {
    const newAmount = parseFloat(e.target.value) || 0;
    const updatedEarnings = [...earnings];
    updatedEarnings[weekIndex] = newAmount;
    setEarnings(updatedEarnings);

    const updatedEditedWeeks = [...editedWeeks];
    updatedEditedWeeks[weekIndex] = true;
    setEditedWeeks(updatedEditedWeeks);
  };

  const getFirmName = (firmId) => {
    const firm = firms.find((firm) => firm.id === firmId);
    return firm ? firm.name : 'N/A';
  };

  const downloadExcelReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportData = [

      { header: 'City', value: person.city || '' },
      { header: 'Godina', value: selectedYear },
      { header: 'Mjesec', value: selectedMonth },
      { header: 'Period', value: selectedPeriod },
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `Tjedan ${startWeek + i}`,
        value: earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
      })),
      { header: '=', value: zaradaTotal || 0 },
      { header: 'FEE', value: fee },
      { header: 'Total 1', value: total1 },
      { header: 'App Knjig', value: appKnjig },
      { header: 'Doprinosi', value: doprinosi },
      { header: 'Renta', value: renta },
      { header: 'Rent Smještaj', value: rentSmjestaj },
      { header: 'Oprema', value: oprema },
      { header: 'Akontacija', value: akontacija },
      { header: 'Gorivo', value: gorivo },
      { header: 'Ostalo', value: ostalo },
      { header: 'Bonus', value: bonus },
      { header: 'Tarifa', value: tarifa },
      { header: 'Struja', value: struja },
      { header: 'O.T.', value: glovoTax },
      { header: 'Deposit', value: depozit },
      { header: '', value: total2 },
    ];

    reportData.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}.xlsx`
    );
  };

  const downloadExcelReportEN = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');
    worksheet.columns = [
      { header: 'Header', key: 'header', width: 30 },
      { header: 'Value', key: 'value', width: 20 },
    ];

    const reportDataEN = [

      { header: 'City', value: person.city || '' },
      { header: 'Year', value: selectedYear },
      { header: 'Month', value: selectedMonth },
      { header: 'Period', value: selectedPeriod },
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `Week ${startWeek + i}`,
        value: earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
      })),
      { header: '=', value: zaradaTotal || 0 },
      { header: 'FEE', value: fee },
      { header: 'Total 1', value: total1 },
      { header: 'App Knjig', value: appKnjig },
      { header: 'Contributions', value: doprinosi },
      { header: 'Renta', value: renta },
      { header: 'Rent Accommodation', value: rentSmjestaj },
      { header: 'Equipment', value: oprema },
      { header: 'Advance Payment', value: akontacija },
      { header: 'Fuel', value: gorivo },
      { header: 'Others', value: ostalo },
      { header: 'Bonus', value: bonus },
      { header: 'Tariff', value: tarifa },
      { header: 'Electricity', value: struja },
      { header: 'O.T.', value: glovoTax },
      { header: 'Deposit', value: depozit },
      { header: '', value: total2 },
    ];

    reportDataEN.forEach(row => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}_EN.xlsx`
    );
  };

  const downloadPDFReport = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportData = [


      ['City', person.city || ''],
      ['Godina', selectedYear],
      ['Mjesec', selectedMonth],
      ['Period', selectedPeriod],
      ...Array.from({ length: numOfWeeks }, (_, i) => [
        `Tjedan ${startWeek + i}`,
        earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
      ]),
      ['=', zaradaTotal || 0],
      ['FEE', fee],
      ['Total 1', total1 || 0],
      ['App Knjig', appKnjig],
      ['Doprinosi', doprinosi],
      ['Renta', renta],
      ['Rent Smještaj', rentSmjestaj],
      ['Oprema', oprema],
      ['Akontacija', akontacija],
      ['Gorivo', gorivo],
      ['Ostalo', ostalo],
      ['Bonus', bonus],
      ['Tarifa', tarifa],
      ['Struja', struja],
      ['O.T.', glovoTax],
      ['Deposit', depozit],
      ['', total2 || 0],
    ];

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportData,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}.pdf`);
  };

  const downloadPDFReportEN = () => {
    const doc = new jsPDF('portrait', 'pt', 'A4');
    const margin = 40;
    const reportDataEN = [
      ['City', person.city || ''],
      ['Year', selectedYear],
      ['Month', selectedMonth],
      ['Period', selectedPeriod],
      ...Array.from({ length: numOfWeeks }, (_, i) => [
        `Week ${startWeek + i}`,
        earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
      ]),
      ['=', zaradaTotal || 0],
      ['FEE', fee],
      ['Total 1', total1 || 0],
      ['App Knjig', appKnjig],
      ['Contributions', doprinosi],
      ['Renta', renta],
      ['Rent Accommodation', rentSmjestaj],
      ['Equipment', oprema],
      ['Advance Payment', akontacija],
      ['Fuel', gorivo],
      ['Others', ostalo],
      ['Bonus', bonus],
      ['Tariff', tarifa],
      ['Electricity', struja],
      ['O.T.', glovoTax],
      ['Deposit', depozit],
      ['', total2 || 0],
    ];

    doc.autoTable({
      startY: margin,
      head: [['Header', 'Value']],
      body: reportDataEN,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 5, valign: 'middle', halign: 'center' },
      headStyles: { fillColor: [245, 245, 220], textColor: 0, fontStyle: 'bold' },
    });
    doc.save(`${person.name}_${selectedMonth}_${selectedYear}_P${selectedPeriod}_EN.pdf`);
  };

  const printReport = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${[
              ['City', person.city || ''],
              ['Godina', selectedYear],
              ['Mjesec', selectedMonth],
              ['Period', selectedPeriod],
              ...Array.from({ length: numOfWeeks }, (_, i) => [
                `Tjedan ${startWeek + i}`,
                earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
              ]),
              ['=', zaradaTotal || 0],
              ['FEE', fee],
              ['Total 1', total1 || 0],
              ['App Knjig', appKnjig],
              ['Doprinosi', doprinosi],
              ['Renta', renta],
              ['Rent Smještaj', rentSmjestaj],
              ['Oprema', oprema],
              ['Akontacija', akontacija],
              ['Gorivo', gorivo],
              ['Ostalo', ostalo],
              ['Bonus', bonus],
              ['Tarifa', tarifa],
              ['Struja', struja],
              ['O.T.', glovoTax],
              ['Deposit', depozit],
              ['', total2 || 0],
            ].map(row => `<tr><td>${row[0]}</td><td>${row[1]}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const printReportEN = () => {
    const printWindow = window.open('', '_blank');
    const documentContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 80%; margin: 20px auto; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid black; padding: 12px; text-align: center; }
            th { background-color: #F5F5DC; font-weight: bold; font-size: 18px; }
            td { font-size: 16px; }
          </style>
        </head>
        <body>
          <h2 style="text-align: center;"></h2>
          <table>
            <tr><th>Header</th><th>Value</th></tr>
            ${[
              ['City', person.city || ''],
              ['Year', selectedYear],
              ['Month', selectedMonth],
              ['Period', selectedPeriod],
              ...Array.from({ length: numOfWeeks }, (_, i) => [
                `Week ${startWeek + i}`,
                earningsData.find(e => e.userId === person.id && e.week === (startWeek + i))?.amount || 0,
              ]),
              ['=', zaradaTotal || 0],
              ['FEE', fee],
              ['Total 1', total1 || 0],
              ['App Knjig', appKnjig],
              ['Contributions', doprinosi],
              ['Renta', renta],
              ['Rent Accommodation', rentSmjestaj],
              ['Equipment', oprema],
              ['Advance Payment', akontacija],
              ['Fuel', gorivo],
              ['Others', ostalo],
              ['Bonus', bonus],
              ['Tariff', tarifa],
              ['Electricity', struja],
              ['O.T.', glovoTax],
              ['Deposit', depozit],
              ['', total2 || 0],
            ].map(row => `<tr><td>${row[0]}</td><td>${row[1]}</td></tr>`).join('')}
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(documentContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleReportOption = async (format) => {
    console.log(format);
    let language = 'hr';
    if (format.endsWith('-en')) {
      language = 'en';
      format = format.slice(0, -3);
    }

    switch (format) {
      case 'xlsx':
        if (language === 'hr') await downloadExcelReport();
        else if (language === 'en') await downloadExcelReportEN();
        break;
      case 'pdf':
        if (language === 'hr') downloadPDFReport();
        else if (language === 'en') downloadPDFReportEN();
        break;
      case 'print':
        if (language === 'hr') printReport();
        else if (language === 'en') printReportEN();
        break;
      default:
        break;
    }
  };

  const handleArchive = async () => {
    if (window.confirm(`Jeste li sigurni da želite arhivirati ${person.name}?`)) {
      try {
        const archiveMonth = selectedMonth;
        const archiveYear = selectedYear;
        await updateDoc(doc(db, 'users', person.id), {
          archived: true,
          archiveMonth,
          archiveYear,
        });
        onUpdatePerson({ ...person, archived: true, archiveMonth, archiveYear });
        closePersonModal();
        closeFinancialModal();
        alert('Osoba uspješno arhivirana!');
      } catch (e) {
        console.error('Greška pri arhiviranju korisnika:', e);
        alert('Došlo je do greške prilikom arhiviranja korisnika. Pokušajte ponovno.');
      }
    }
  };

  return (
    <>
      <tr>
        <td className={isRowSelected ? 'selected-cell' : ''} style={{position:'relative'}}>
          <span
            className="person-name-tooltip-wrapper"
            style={{position:'relative',display:'inline-block'}}
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
          >
            {person.name}
          </span>
          <TooltipPortal
            visible={tooltip.visible}
            content={tooltip.content}
            x={tooltip.x}
            y={tooltip.y}
            preferSide="right"
          />
        </td>
        <td className={isRowSelected ? 'selected-cell' : ''}>
          <button className="edit-button" onClick={openReportModal} title="Report">
            <FaDownload /> Izvještaj
          </button>
          <button className="edit-button" onClick={openPersonModal} title="Uredi osobu">
            <FaEdit /> Osoba
          </button>
          <button className="edit-button" onClick={openFinancialModal} title="Uredi financije">
            <FaEdit /> Finan
          </button>
        </td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{person.riderID}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{person.city || ''}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{getFirmName(person.firmId)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{person.nationality === 'Hrvat' ? 'H' : 'S'}</td>
        {earnings.map((earning, index) => (
          <td className={isRowSelected ? 'selected-cell' : ''} key={index}>{earning.toFixed(2)}</td>
        ))}
        <td className={isRowSelected ? 'selected-cell' : ''}>{zaradaTotal.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{fee}%</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{feeAmount}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{total1}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{appKnjig.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{doprinosi.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{renta.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{rentSmjestaj.toFixed(2)}</td>
        <>
          <td className={isRowSelected ? 'selected-cell' : ''}>{tarifa.toFixed(2)}</td>
          <td className={isRowSelected ? 'selected-cell' : ''}>{glovoTax.toFixed(2)}</td>
        </>
        <td className={isRowSelected ? 'selected-cell' : ''}>{oprema.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{akontacija.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{gorivo.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{ostalo.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{bonus.toFixed(2)}</td>
        <td className={isRowSelected ? 'selected-cell' : ''}>{total2}</td>
      </tr>

      <ReportModal 
        isOpen={isReportModalOpen} 
        onRequestClose={closeReportModal} 
        onGenerateReport={handleReportOption} 
      />

      <Modal
        isOpen={isPersonModalOpen}
        onRequestClose={closePersonModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi osobu</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Ime:</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Nacionalnost:</label>
            <select value={nationality} onChange={(e) => setNationality(e.target.value)}>
              <option value="Hrvat">Hrvat</option>
              <option value="Stranac">Stranac</option>
            </select>
          </div>
          <div className="form-group">
            <label>Rider ID:</label>
            <input type="text" value={riderID} onChange={(e) => setRiderID(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Grad:</label>
            <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Firma:</label>
            <select value={firmId} onChange={(e) => setFirmId(e.target.value)} required>
              <option value="default">Default</option>
              {firms.filter((firm) => firm.id !== 'default').map((firm) => (
                <option key={firm.id} value={firm.id}>{firm.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Tekući račun:</label>
            <input type="text" value={tekuciRacun} onChange={(e) => setTekuciRacun(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Zaštićeni račun:</label>
            <input type="text" value={zasticeniRacun} onChange={(e) => setZasticeniRacun(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Komentar:</label>
            <input
              type="text"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Komentar"
            />
          </div>
          <div className="form-group">
            <label>Početni mjesec rada:</label>
            <select value={startMonth} onChange={(e) => setStartMonth(parseInt(e.target.value))}>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Početna godina rada:</label>
            <select value={startYear} onChange={(e) => setStartYear(parseInt(e.target.value))}>
              {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>App Knjig. (default):</label>
            <input
              type="number"
              value={appKnjigDefault}
              onChange={(e) => setAppKnjigDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Doprinosi (default):</label>
            <input
              type="number"
              value={doprinosiDefault}
              onChange={(e) => setDoprinosiDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Fee % (default):</label>
            <input
              type="number"
              value={feeDefault}
              onChange={(e) => setFeeDefault(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>Renta (default):</label>
            <input
              type="number"
              value={rentaDefault}
              onChange={(e) => setRentaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent smještaj (default):</label>
            <input
              type="number"
              value={rentSmjestajDefault}
              onChange={(e) => setRentSmjestajDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Oprema (default):</label>
            <input
              type="number"
              value={opremaDefault}
              onChange={(e) => setOpremaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Akontacija (default):</label>
            <input
              type="number"
              value={akontacijaDefault}
              onChange={(e) => setAkontacijaDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Gorivo (default):</label>
            <input
              type="number"
              value={gorivoDefault}
              onChange={(e) => setGorivoDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo (default):</label>
            <input
              type="number"
              value={ostaloDefault}
              onChange={(e) => setOstaloDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus (default):</label>
            <input
              type="number"
              value={bonusDefault}
              onChange={(e) => setBonusDefault(parseFloat(e.target.value) || 0)}
            />
          </div>
          {nationality === 'Stranac' && (
            <>
              <div className="form-group">
                <label>Tarifa (default):</label>
                <input
                  type="number"
                  value={tarifaDefault}
                  onChange={(e) => setTarifaDefault(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Overtime Tax (default):</label>
                <input
                  type="number"
                  value={glovoTaxDefault}
                  onChange={(e) => setGlovoTaxDefault(parseFloat(e.target.value) || 0)}
                />
              </div>
            </>
          )}
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSavePerson}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closePersonModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleArchive}>Arhiviraj</button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isFinancialModalOpen}
        onRequestClose={closeFinancialModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi financijske podatke</h2>
        <form className="edit-person-form">
          <div className="form-group">
            <label>Fee %:</label>
            <input
              type="number"
              value={fee}
              onChange={(e) => setFee(parseFloat(e.target.value) || 0)}
              min="0"
              max="100"
            />
          </div>
          <div className="form-group">
            <label>App Knjig.:</label>
            <input
              type="number"
              value={appKnjig}
              onChange={(e) => setAppKnjig(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Doprinosi:</label>
            <input
              type="number"
              value={doprinosi}
              onChange={(e) => setDoprinosi(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Renta:</label>
            <input
              type="number"
              value={renta}
              onChange={(e) => setRenta(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Rent smještaj:</label>
            <input
              type="number"
              value={rentSmjestaj}
              onChange={(e) => setRentSmjestaj(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Oprema:</label>
            <input
              type="number"
              value={oprema}
              onChange={(e) => setOprema(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Akontacija:</label>
            <input
              type="number"
              value={akontacija}
              onChange={(e) => setAkontacija(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Gorivo:</label>
            <input
              type="number"
              value={gorivo}
              onChange={(e) => setGorivo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Ostalo:</label>
            <input
              type="number"
              value={ostalo}
              onChange={(e) => setOstalo(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Bonus:</label>
            <input
              type="number"
              value={bonus}
              onChange={(e) => setBonus(parseFloat(e.target.value) || 0)}
            />
          </div>
          <div className="form-group">
            <label>Napomena:</label>
            <input
              type="text"
              value={napomena}
              onChange={(e) => setNapomena(e.target.value)}
            />
          </div>
          {person.nationality === 'Stranac' && (
            <>
              <div className="form-group">
                <label>Tarifa:</label>
                <input
                  type="number"
                  value={tarifa}
                  onChange={(e) => setTarifa(parseFloat(e.target.value) || 0)}
                />
              </div>
              <div className="form-group">
                <label>Overtime Tax:</label>
                <input
                  type="number"
                  value={glovoTax}
                  onChange={(e) => setGlovoTax(parseFloat(e.target.value) || 0)}
                />
              </div>
            </>
          )}
          <div className="form-group">
            <button type="button" className="edit-button" onClick={openEarningsModal} title="Uredi zarade">
              <FaEdit /> Uredi zarade po tjednima
            </button>
          </div>
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveFinancial}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeFinancialModal}>Odustani</button>
            <button type="button" className="delete-button" onClick={handleDeleteFinancialData}>
              Resetiraj na zadane vrijednosti
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEarningsModalOpen}
        onRequestClose={closeEarningsModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Uredi zarade po tjednima</h2>
        <form className="edit-person-form">
          {[...Array(numOfWeeks)].map((_, i) => {
            const weekNumber = startWeek + i;
            return (
              <div className="form-group" key={i} style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ flex: '1', marginRight: '10px' }}>Tjedan {weekNumber}:</label>
                <input
                  type="number"
                  value={earnings[i]}
                  onChange={(e) => handleEarningChange(e, i)}
                  style={{ flex: '2', marginRight: '10px' }}
                />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteEarning(i)}
                  title="Obriši zaradu"
                  style={{ padding: '5px 10px', fontSize: '14px' }}
                >
                  <FaTrash />
                </button>
              </div>
            );
          })}
          <div className="button-group">
            <button type="button" className="save-button" onClick={handleSaveEarnings}>Spremi</button>
            <button type="button" className="cancel-button" onClick={closeEarningsModal}>Odustani</button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default PersonRow;